export const DealerMapConfig = {
    mapOptions: {
        zoom: 10,
        zoomControlOptions: {
          style: 2 // Reset when Google Map script is initialized (i.e. window.google.maps is available)
        }
    },
    directionsRendererOptions: {
        draggable: false,
        panel: null
    }
};
